import { classNames } from "@/utils/classNames"
import { ArrowDownIcon, ArrowRightIcon, ArrowUpIcon } from "@heroicons/react/24/outline"
import { FC } from "react"
import { ValueTrend } from "../../types/LabReport"

export const TrendBadge: FC<ValueTrend> = ({ percent, direction, type, valueType }) => {
  return (
    <div
      className={classNames(
        // Text color
        valueType === "normal" ? "text-gray-900" : "text-red-600",
        // Badge color
        type === "positive" && valueType === "abnormal"
          ? "badge-light-green"
          : type === "negative" && valueType === "abnormal"
            ? "badge-purple"
            : "badge",
      )}>
      <span className={`mr-1`}>
        {direction === "up" ? (
          <ArrowUpIcon className="h-[14px] w-[14px]" />
        ) : direction === "down" ? (
          <ArrowDownIcon className="h-[14px] w-[14px]" />
        ) : (
          <ArrowRightIcon className="h-[14px] w-[14px]" />
        )}
      </span>
      <span>{(percent ?? 0).toFixed(1)}%</span>
    </div>
  )
}
